import Vue from 'vue'

export default {
  SET_MINHAS_EMPRESAS(state, empresas) {
    Vue.set(state, 'minhasEmpresas', empresas)
  },
}
